const routes = [
	{
		path: '/servicios',
		component: () => import('@/views/dashboard/services/List.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/agregar/servicio',
		component: () => import('@/views/dashboard/services/Add.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/servicio/:name',
		component: () => import('@/views/dashboard/services/Edit.vue'),
		meta: {
			auth: true
		}
	}
];

export default routes;